var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _dec4, _dec5, _dec6, _class2, _descriptor4, _descriptor5, _descriptor6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class3, _class4, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import objectTrait from "../Decorators/objectTrait";
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import ModelTraits from "../ModelTraits";
import { traitClass } from "../Trait";
import mixTraits from "../mixTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
import DiscretelyTimeVaryingTraits from "./DiscretelyTimeVaryingTraits";
import ImageryProviderTraits from "./ImageryProviderTraits";
import LayerOrderingTraits from "./LayerOrderingTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import { MinMaxLevelTraits } from "./MinMaxLevelTraits";
import UrlTraits from "./UrlTraits";
export let ArcGisImageServerRenderingRule = (_dec = primitiveTrait({
  type: "string",
  name: "Name",
  description: "The name of the raster function."
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Description",
  description: 'optional for well known functions, default is "Raster" for raster function templates.'
}), _dec3 = anyTrait({
  name: "Arguments",
  description: "Overwrite the raster function default configuration by specifying argument parameters (argument names and value types are defined by the author of each raster function template and are not discoverable through ArcGis REST API)."
}), _class = class ArcGisImageServerRenderingRule extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "rasterFunction", _descriptor, this);
    _initializerDefineProperty(this, "variableName", _descriptor2, this);
    _initializerDefineProperty(this, "rasterFunctionArguments", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "rasterFunction", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "variableName", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "rasterFunctionArguments", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export let ArcGisImageServerAvailableRasterFunctionTraits = (_dec4 = primitiveTrait({
  type: "string",
  name: "Name",
  description: "The name of the raster function."
}), _dec5 = primitiveTrait({
  type: "string",
  name: "Description",
  description: "The description of the raster function."
}), _dec6 = primitiveTrait({
  type: "string",
  name: "Unit",
  description: "Help text for the raster function"
}), _class2 = class ArcGisImageServerAvailableRasterFunctionTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "name", _descriptor4, this);
    _initializerDefineProperty(this, "description", _descriptor5, this);
    _initializerDefineProperty(this, "help", _descriptor6, this);
  }
}, _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "description", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "help", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
let ArcGisImageServerCatalogItemTraits = (_dec7 = traitClass({
  example: {
    url: "https://sampleserver6.arcgisonline.com/arcgis/rest/services/CharlotteLAS/ImageServer",
    type: "esri-imageServer",
    name: "CharlotteLAS"
  }
}), _dec8 = primitiveTrait({
  type: "number",
  name: "Maximum scale",
  description: "Gets or sets the denominator of the largest scale (smallest denominator) for which tiles should be requested.  For example, if this value is 1000, then tiles representing a scale larger than 1:1000 (i.e. numerically smaller denominator, when zooming in closer) will not be requested.  Instead, tiles of the largest-available scale, as specified by this property, will be used and will simply get blurier as the user zooms in closer. Note: maximumLevel overrides this property."
}), _dec9 = anyTrait({
  name: "Parameters",
  description: "Additional parameters to pass to the ImageServer when requesting images."
}), _dec0 = primitiveTrait({
  name: "Token URL",
  description: "URL to use for fetching request tokens. Note this will override the token trait if both are set.",
  type: "string"
}), _dec1 = primitiveTrait({
  name: "Token",
  description: "Token to use for ArcGiS REST API requests (if not using tokenUrl)",
  type: "string"
}), _dec10 = primitiveTrait({
  type: "number",
  name: "Maximum Refresh Intervals",
  description: "The maximum number of discrete times that can be created by a single " + "date range when layer in time-enabled."
}), _dec11 = primitiveTrait({
  type: "number",
  name: "WKID",
  description: "The well-known ID of the spatial reference of the image server. Only Web Mercator (102100 or 102113 or 3857) and WGS84 (4326) are supported."
}), _dec12 = primitiveTrait({
  name: "Use Pre-Cached Tiles",
  description: "If true, the server's pre-cached tiles are used. If false, then the ImageServer exportImage endpoint will be used. This will default to false if parameters (including time) have been specified, otherwise it will default to true if a server supports pre-cached tiles.",
  type: "boolean"
}), _dec13 = primitiveArrayTrait({
  name: "Band IDs",
  description: "The band IDs to use when requesting images.",
  type: "number"
}), _dec14 = objectTrait({
  name: "Rendering Rule",
  description: 'The rendering rule to apply to the image service. This must be a JSON object - for example `{"rasterFunction": "RFTAspectColor"}`. Note `allowRasterFunction` must be true for this to be applied.',
  type: ArcGisImageServerRenderingRule
}), _dec15 = primitiveTrait({
  name: "Allow Raster Function",
  description: "If true, then the renderingRule will be applied to the image service. If false, the renderingRule will be ignored. This will default to true if an image service supports raster functions.",
  type: "boolean"
}), _dec16 = objectArrayTrait({
  type: ArcGisImageServerAvailableRasterFunctionTraits,
  name: "Available raster functions",
  description: "The available raster functions for the ImageServer. Defaults to all raster functions in the service if the server supports raster functions. Note: `allowRasterFunction` must be true. To set the default raster function, use the `renderingRule` property.",
  idProperty: "name"
}), _dec17 = primitiveTrait({
  name: "Disable raster functions selectors",
  description: "When true, disables the dimension selectors in the workbench. This will default to true if the server does not support raster functions.",
  type: "boolean"
}), _dec7(_class3 = (_class4 = class ArcGisImageServerCatalogItemTraits extends mixTraits(ImageryProviderTraits, LayerOrderingTraits, UrlTraits, CatalogMemberTraits, LegendOwnerTraits, DiscretelyTimeVaryingTraits, MinMaxLevelTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "maximumScale", _descriptor7, this);
    _initializerDefineProperty(this, "parameters", _descriptor8, this);
    _initializerDefineProperty(this, "tokenUrl", _descriptor9, this);
    _initializerDefineProperty(this, "token", _descriptor0, this);
    _initializerDefineProperty(this, "maxRefreshIntervals", _descriptor1, this);
    _initializerDefineProperty(this, "wkid", _descriptor10, this);
    _initializerDefineProperty(this, "usePreCachedTiles", _descriptor11, this);
    _initializerDefineProperty(this, "bandIds", _descriptor12, this);
    _initializerDefineProperty(this, "renderingRule", _descriptor13, this);
    _initializerDefineProperty(this, "allowRasterFunction", _descriptor14, this);
    _initializerDefineProperty(this, "availableRasterFunctions", _descriptor15, this);
    _initializerDefineProperty(this, "disableRasterFunctionSelectors", _descriptor16, this);
  }
}, _descriptor7 = _applyDecoratedDescriptor(_class4.prototype, "maximumScale", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class4.prototype, "parameters", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class4.prototype, "tokenUrl", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class4.prototype, "token", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class4.prototype, "maxRefreshIntervals", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 10000;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class4.prototype, "wkid", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 102100;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class4.prototype, "usePreCachedTiles", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class4.prototype, "bandIds", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class4.prototype, "renderingRule", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class4.prototype, "allowRasterFunction", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class4.prototype, "availableRasterFunctions", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class4.prototype, "disableRasterFunctionSelectors", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class4)) || _class3);
export { ArcGisImageServerCatalogItemTraits as default };